import React from 'react';

import { VerificationRequestsTable } from 'src/components/reports';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const VerificationRequestsReportPage: React.FC = () => {
  return (
    <TableDataProvider>
      <VerificationRequestsTable />
    </TableDataProvider>
  );
};
